import PropTypes from 'prop-types';
import React, { createContext, useContext } from 'react';

export const AttendeeModeContext = createContext();

export const useAttendeeMode = () => {
    return useContext(AttendeeModeContext);
};

export const AttendeeModeProvider = ({ children, value }) => {
    return <AttendeeModeContext.Provider value={value}>{children}</AttendeeModeContext.Provider>;
};

AttendeeModeProvider.propTypes = {
    children: PropTypes.node.isRequired,
    value: PropTypes.object,
};
